import type {PictureField} from "@buildwithflux/accounts-schema";

/**
 * Data returned by the adapter for a given user UID.
 * The component uses this to resolve and render the avatar.
 */
export interface AvatarData {
    readonly picture: PictureField | null;
    readonly displayName: string | null;
}

/**
 * Contract that each host app implements to provide avatar data.
 * The domain component calls the adapter's hook to fetch user data.
 *
 * - Frontend: wraps ViewAwareUserRepository / FluxServices
 * - Site-search: reads Firestore view collection directly via modular SDK
 */
export interface AvatarAdapter {
    /**
     * React hook that subscribes to avatar data for a given UID.
     * Returns undefined while loading, null if user not found,
     * or AvatarData when available.
     */
    useAvatarData(uid: string | null): AvatarData | undefined;
}

/**
 * No-op adapter that always returns undefined.
 * Used as the default context value so that useAvatarData is always
 * called unconditionally (Rules of Hooks compliance).
 */
export const NO_OP_ADAPTER: AvatarAdapter = {
    useAvatarData: () => undefined,
};
